import type {FC} from 'react';

import type {Size} from './types';

import * as S from './styles';

type Props = {
  isSelected?: boolean;
  label: string;
  onClick?: () => void;
  size?: Size;
  width?: number;
};

export const Option: FC<Props> = ({
  isSelected = false,
  label,
  onClick,
  size = 'me',
  width,
}) => {
  return (
    <S.Container
      isSelected={isSelected}
      onClick={onClick}
      size={size}
      width={width}
    >
      <S.Label color={isSelected ? 'text.white' : 'text.gray'}>{label}</S.Label>
    </S.Container>
  );
};
